export const convertToCSV = (data: any[], headers: string[]): string => {
  if (!data || data.length === 0) return '';
  
  const csvHeaders = headers.join(',');
  const csvRows = data.map(row => {
    return headers.map(header => {
      const value = row[header];
      // Handle null/undefined
      if (value === null || value === undefined) return '';
      // Handle arrays and objects
      if (typeof value === 'object') return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
      // Handle strings with commas or quotes
      if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',');
  });
  
  return [csvHeaders, ...csvRows].join('\n');
};

export const downloadCSV = (csv: string, filename: string) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportTableToCSV = (data: any[], tableName: string, headers?: string[]) => {
  if (!data || data.length === 0) {
    console.warn(`No data to export for table: ${tableName}`);
    return;
  }
  
  const tableHeaders = headers || Object.keys(data[0]);
  const csv = convertToCSV(data, tableHeaders);
  const timestamp = new Date().toISOString().split('T')[0];
  downloadCSV(csv, `${tableName}_${timestamp}.csv`);
};
